module.exports = require("frontend-restclient");